"use strict";
/**
 * AI Conversation Types
 *
 * DynamoDB record shapes for AI conversations, shared between frontend and backend.
 * These are distinct from the link-based Conversation types in conversation.ts,
 * which represent the target architecture for artifact-linked sessions.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ai-conversation.js.map